import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseComponent } from '../../../../core/layout/components/abstracts/base.component';
import { IOtsStaffOrderCard } from '../../core/interfaces/IOtsStaffOrderCard';
import { StaffOrderCardComponent } from '../staff-order-card/staff-order-card.component';

@Component({
  selector: 'ots-staff-order-column',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [StaffOrderCardComponent],
  templateUrl: './staff-order-column.component.html',
  styleUrl: './staff-order-column.component.scss',
  host: {
    class: 'ots-staff-column d-flex flex-direction-column gap-16 overflow-hidden c-bg-gray-200 large-border-radius p-y-16 p-x-12'
  }
})
export class StaffOrderColumnComponent extends BaseComponent {

  @Input() public title = '';

  @Input() public cards: IOtsStaffOrderCard[] = [];

  @Output() public advanceStatus = new EventEmitter<string>();
}
